<div class="modal-header"><h2 class="modal-title">Double Check</h2></div>
<div class="modal-body">
  <div class="instruction-text force-left">Select batches to compare</div>
  <div class="d-flex flex-row m-2 mb-3">
    <dx-form [formData]="selectedBatches" style="min-width: 450px">
      <dxi-item [label]="{ text: 'Batch #1' }">
        <div *dxTemplate>
          <dx-select-box [(value)]="batch1Id" [items]="batches" [valueExpr]="'id'" [displayExpr]="'name'"> </dx-select-box>
        </div>
      </dxi-item>
      <dxi-item [label]="{ text: 'Batch #2' }">
        <div *dxTemplate>
          <dx-select-box [(value)]="batch2Id" [items]="batches" [valueExpr]="'id'" [displayExpr]="'name'"> </dx-select-box>
        </div>
      </dxi-item>
    </dx-form>
    <div class="d-flex flex-column ms-3">
      <div class="cash-check-text + {{ doubleCheckComplete ? (cashBreakdownCheck.isMatch ? ' pass' : ' fail') : '' }}">
        Total Cash In Batch: {{ cashBreakdownCheck.batchTotalCash | currency }}
      </div>
      <div class="cash-check-text + {{ doubleCheckComplete ? (cashBreakdownCheck.isMatch ? ' pass' : ' fail') : '' }}">
        Sum of Cash Breakdown: {{ cashBreakdownCheck.cashBreakdownTotalCash | currency }}
      </div>
      @if (doubleCheckComplete && !cashBreakdownCheck.isMatch) {
        <div class="double-check-text fail">Cash Breakdown Check - Failed</div>
      }
    </div>
  </div>

  <div class="d-flex flex-column">
    @if (!doubleCheckComplete) {
      <div class="instruction-text">Waiting to compare batches</div>
    }
    @if (doubleCheckComplete) {
      <div class="d-flex flex-row">
        <h3 class="col-sm-6 m-1">Amounts</h3>
        <h3 class="col-sm-6 m-1">Check Numbers</h3>
      </div>
    }
    <div class="d-flex flex-row">
      @if (doubleCheckComplete) {
        <div class="col-sm-6 m-1" style="border: solid">
          @if (doubleCheck.length === 0) {
            <div class="double-check-text">Amounts Passed</div>
          }
          @if (doubleCheck.length > 0) {
            <dx-data-grid
              #doubleCheckGrid
              class="m-2"
              [dataSource]="doubleCheck"
              keyExpr="envelope"
              [columnAutoWidth]="false"
              [height]="500"
              [showBorders]="true"
              >
              <dxi-column dataField="envelope" dataType="text" caption="Box" width="100" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>
              <dxi-column
                dataField="difference"
                caption="Difference"
                dataType="number"
                [format]="{ type: 'currency', precision: 2 }"
                width="125"
                cssClass="align-right-pad"
              ></dxi-column>
              <dxi-column
                dataField="batch1Total"
                caption="Batch #1"
                dataType="number"
                [format]="{ type: 'currency', precision: 2 }"
                width="125"
                cssClass="align-right-pad"
              ></dxi-column>
              <dxi-column
                dataField="batch2Total"
                caption="Batch #2"
                dataType="number"
                [format]="{ type: 'currency', precision: 2 }"
                width="125"
                cssClass="align-right-pad"
              ></dxi-column>
            </dx-data-grid>
          }
        </div>
      }

      @if (doubleCheckComplete) {
        <div class="col-sm-6 m-1" style="border: solid">
          @if (doubleCheckForCheckNumbers.length === 0) {
            <div class="ms-auto double-check-text">Check Numbers Passed</div>
          }
          @if (doubleCheckForCheckNumbers.length > 0) {
            <dx-data-grid
              #checkNumberGrid
              class="m-2"
              [dataSource]="doubleCheckForCheckNumbers"
              keyExpr="envelopeNumber"
              [columnAutoWidth]="false"
              [height]="500"
              [showBorders]="true"
              >
              <dxi-column dataField="envelopeNumber" dataType="text" caption="Box" width="100" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>
              <dxi-column dataField="checkNumber" caption="Check #"></dxi-column>
            </dx-data-grid>
          }
        </div>
      }
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="compare()" [hidden]="disableCompare || doubleCheckPassed">Compare</button>
  <button type="button" class="btn btn-primary" (click)="close()">Close</button>
</div>
